import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { navigate } from '@reach/router';
import { Pane, Spinner, toaster } from 'evergreen-ui';

const InvitationAccept = ({
  authenticated,
  acceptInvitation,
  updateInvitationToken,
}) => {
  useEffect(() => {
    const [, token] = window.location.search.split('?token=');
    if (authenticated) {
      const initAccept = async () => {
        const success = await acceptInvitation(token);

        if (success) {
          toaster.success('Invitation Accepted', {
            duration: 2,
          });

          navigate(`/dashboard`);
        } else {
          toaster.danger('Could Not Accept Invitation', {
            duration: 2,
          });
          navigate(`/`);
        }
      };

      initAccept();
    } else {
      updateInvitationToken(token);
      toaster.danger('Please Login First to Accept Invitaion');
      navigate(`/`);
    }
  }, [authenticated, acceptInvitation, updateInvitationToken]);

  return (
    <Pane
      display='flex'
      alignItems='center'
      justifyContent='center'
      height='100vh'
    >
      <Spinner />
    </Pane>
  );
};

const mapState = (state) => {
  const accessToken = state.auth.access;

  return {
    authenticated: accessToken !== '',
  };
};

const mapDispatch = (dispatch) => ({
  acceptInvitation: (token) => dispatch.auth.acceptInvitation(token),
  updateInvitationToken: (token) => dispatch.auth.updateInvitationToken(token),
});

export default connect(mapState, mapDispatch)(InvitationAccept);
